import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BancheRoutingModule } from './banche-routing.module';
import { BancheComponent } from './banche.component';
import { BancheDetailsComponent } from './banche-details/banche-details.component';
import { BancheListComponent } from './banche-list/banche-list.component';
import { BancheEditComponent } from './banche-edit/banche-edit.component';

import { FormsModule } from '@angular/forms';
import { BancheCreateComponent } from './banche-create/banche-create.component';
import { MyCustomMaterialModule } from 'san-common';


@NgModule({
  imports: [
    CommonModule,
    BancheRoutingModule,
    MyCustomMaterialModule,
    FormsModule
  ],
  declarations: [
    BancheComponent,
    BancheListComponent,
    BancheDetailsComponent,
    BancheCreateComponent,
    BancheEditComponent
    ]
})
export class BancheModule { }
